import React from "react";
import trace from "../../../../../helpers/trace";
import { deleteByCharacter } from "../../../../../helpers/strings";
import { openCloseToast } from "../../../../Global/actions";
import {
  allRolesByProfileId,
  createUserByRol,
  deleteRolesByUser,
  overrideRolesForUser,
  getEmplyeesByCompanyRut,
  getUserRolesPortalEmpresa,
  getAllGruposPortalEmpresa,
  getAllRolesPortalEmpresa,
  updatePortalEmpresaForUser,
  deleteRolesTrabajador,
} from "../../../../../services/userRolesApi";
import constants from "../../../../../helpers/constants";
import { store } from "../../../../../config/store";
import swal from "helpers/swal.lib";

export const modifying = (phase) => ({
  type: "MODIFYING_ASIGNAR_ROLES",
  phase,
});

export const loading = (isLoading) => ({
  type: "LOADING_ASIGNAR_ROLES",
  isLoading,
});

export const showHideLoadingResume = (show) => ({
  type: "SHOW_HIDE_LOADING_RESUME",
  show,
});

export const setRoles = (roles) => ({
  type: "SET_ROLES",
  roles,
});

export const setEmployees = (employees) => ({
  type: "SET_EMPLOYESS",
  employees,
});

export const setRolesFilter = (filter) => ({
  type: "SET_ROLES_FILTER",
  filter,
});

export const openCloseModalEditarRoles = (isOpen, data) => ({
  type: "OPEN_CLOSE_MODAL_EDITAR_ROLES",
  isOpen,
  data,
});

export const openCloseSelectRoles = (isOpen) => ({
  type: "OPEN_CLOSE_SELECT_ROLES",
  isOpen,
});

export const openCloseSelectGrupos = (isOpen) => ({
  type: "OPEN_CLOSE_SELECT_GRUPOS",
  isOpen,
});

export const setSelectedTrabajador = (newData) => ({
  type: "SET_SELECTED_TRABAJADOR",
  newData,
});

export const setSelectedTab = (tab) => ({
  type: "SET_SELECTED_TAB",
  tab,
});

export const setLoadingResumeData = (data) => ({
  type: "SET_LOADING_RESUME_DATA",
  data,
});

export const setDataUserPortalEmpresa = (data) => ({
  type: "SET_DATA_USER_PORTAL_EMPRESA",
  data,
});

export const openCloseModalDelRoles = (isOpen, data) => ({
  type: "OPEN_CLOSE_MODAL_DEL_ROLES",
  isOpen,
  data,
});

export const delRolesTrabajador = data => ({
  type: 'DEL_ROLES_TRABAJADOR',
  data,
})

export const doDelRolesTrabajador = (data) => async (dispatch) => {
  dispatch(loading(true));
  dispatch(modifying(1));
  try {
    await deleteRolesTrabajador(data)
    swal.alertCloseButton(null,
      <div className="modal-del-rol-suc">
        <br/>
            <h5>El usuario {data.employeeName}</h5>
            <h5>¡Ha sido eliminado con éxito!</h5>
        <br/>
        <br/>
      </div>
      );
      dispatch(loading(false));
      dispatch(modifying(0));
} catch (error) {
    dispatch(modifying(-1));
    swal.alertCloseButton(null,
      <div className="modal-del-rol-suc">
                <h5>¡Ha ocurrido un error!</h5>
      </div>
      );
  }
};

/**
 * Reducer para guardar la pagina actual de la tabla
 * de Gestión de usuarios en roles
 */
export const setCurrentPageGestionRolesUsuario = (currentPage) => ({
  type: "SET_CURRENT_PAGE_USERS",
  currentPage,
});

/**
 * Reducer para guardar la pagina el size de la tabla
 * de Gestión de usuarios en roles
 */
export const setPageSizeGestionRolesUsuario = (pageSize) => ({
  type: "SET_CURRENT_PAGE_SIZE_USERS",
  pageSize,
});

/**
 * Action para guardar la busqueda por texto de la tabla roles en redux
 */
export const setPageEmployeeSearch = (employeeSearch) => ({
  type: "SET_SEARCH_USER",
  employeeSearch,
});

export const setRolesTrabajadorFilterGestion = filters => ({
  type: 'SET_ROLES_TRABAJADOR_FILTER_GESTION',
  filters,
})

export const setRolesEmpresaFilterGestion = filters => ({
  type: 'SET_ROLES_EMPRESA_FILTER_GESTION',
  filters,
})

export const doGetUserPortalEmpresa = () => async (dispatch) => {
  const toast = {};
  dispatch(loading(true));
  try {
    const { selectedTrabajador } = store.getState().asignacionRoles;
    const request = await getUserRolesPortalEmpresa(
      deleteByCharacter(selectedTrabajador.Rut, "-")
    );

    selectedTrabajador[constants.idTabPortalEmpresa] = {
      Grupos: [],
      Roles: [],
    };
    if (request.status === 200) {
      const result = await request.json();
      if (result.User) {
        selectedTrabajador[
          constants.idTabPortalEmpresa
        ].Grupos = result.User.GruposList.map((item) => ({
          Id: item,
          Name: item,
        }));
        selectedTrabajador[
          constants.idTabPortalEmpresa
        ].Roles = result.User.RolesList.map((item) => ({
          Id: item,
          Name: item,
        }));
        dispatch(setDataUserPortalEmpresa(result.User));
      } else {
        dispatch(setDataUserPortalEmpresa({}));
      }
    }
    dispatch(setSelectedTrabajador(selectedTrabajador));
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const doUpdateUserRoles = (userData, companyRut) => async (dispatch) => {
  dispatch(showHideLoadingResume(true));
  const toast = {};
  try {
    let shouldClose = true;
    //  se envia la data modificada para cada parte
    if (userData.edited) {
      shouldClose = false;
      const idRoles = userData.Roles.map((item) => item.Id);
      dispatch(addRolesToUser(userData, companyRut, idRoles));
    }
    if (userData[constants.idTabLGF] && userData[constants.idTabLGF].edited) {
      shouldClose = false;
      dispatch(addRolesLGFToUser(userData));
    }
    if (
      userData[constants.idTabAchsGestion] &&
      userData[constants.idTabAchsGestion].edited
    ) {
      shouldClose = false;
      dispatch(addRolesAchsGestionToUser(userData));
    }
    if (
      userData[constants.idTabPortalEmpresa] &&
      userData[constants.idTabPortalEmpresa].edited
    ) {
      shouldClose = false;
      dispatch(addRolesPortalEmpresaToUser(userData, companyRut));
    }

    if (shouldClose) {
      dispatch(openCloseModalEditarRoles(false, {}));
      dispatch(showHideLoadingResume(false));
    }
  } catch (e) {
    trace.information("Error doUpdateUserRoles", e);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
};

export const addRolesPortalEmpresaToUser = (selectedUser, CompanyRut) => async (
  dispatch
) => {
  const toast = {};
  const {
    loadingResumeData,
    userPortalEmpresa,
  } = store.getState().asignacionRoles;
  const { roles } = store.getState().mantenedores;
  try {
    loadingResumeData[constants.idTabPortalEmpresa] = {
      detail: "",
      state: constants.stateLoading,
    };
    dispatch(setLoadingResumeData(loadingResumeData));
    let updatedRoles;
    let updatedGrupos;
    let updatedEmpresas;

    if (selectedUser[constants.idTabPortalEmpresa].Roles) {
      updatedRoles = selectedUser[constants.idTabPortalEmpresa].Roles.map(
        (r) => r.Id
      ).join(";");
    }
    if (selectedUser[constants.idTabPortalEmpresa].Grupos) {
      const rolAuto = selectedUser[constants.idTabPortalEmpresa].Roles.find(r => r.Id === constants.idRolAutoasignacion)

      updatedGrupos = selectedUser[constants.idTabPortalEmpresa].Grupos.map(
        (r) => r.Id
      ).join(";");

      updatedGrupos = rolAuto ? updatedGrupos.concat(`;${constants.idGrupoSuperUsuario}`) : updatedGrupos
    }

    if (
      !userPortalEmpresa.Empresas ||
      (userPortalEmpresa.Empresas &&
        userPortalEmpresa.Empresas.indexOf(CompanyRut) === -1)
    ) {
      updatedEmpresas = userPortalEmpresa.Id ? null : CompanyRut;
    }

    const aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    const splitNombre = selectedUser.EmployeeName.split(" ");
    const name = userPortalEmpresa.Nombre || splitNombre[0];
    const lastName =
      userPortalEmpresa.Apellido ||
      splitNombre.slice(1, splitNombre.length).join(" ");
    const anyRolOrGroup =
      selectedUser[constants.idTabPortalEmpresa].Grupos.length > 0 ||
      selectedUser[constants.idTabPortalEmpresa].Roles.length > 0;

    const data = {
      CrearUsuario: userPortalEmpresa.Id == null,
      Id: deleteByCharacter(selectedUser.Rut, "-"),
      Nombre: name.trim(),
      Apellido: lastName.trim(),
      Email:
        userPortalEmpresa.Email || selectedUser.Email
          ? selectedUser.Email.trim()
          : null,
      Telefono:
        userPortalEmpresa.Telefono || selectedUser.CellPhone
          ? selectedUser.CellPhone.trim()
          : null,
      Roles: updatedRoles,
      Grupos: updatedGrupos,
      Empresas: updatedEmpresas,
      Empresa_Mod: userPortalEmpresa.Id == null ? "1" : "0",
    };

    // this update can create or update users
    const request = await updatePortalEmpresaForUser(data);

    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        const rolPortalEmpresa = roles.find(
          (f) => f.Code === constants.codeRolPortalEmpresa
        );
        // si no tiene el rol en achvirtual
        // if (selectedUser.Roles.findIndex((r) => r.Id === rolPortalEmpresa.Id) === -1) {
        // y se agregaron roles al portal empresa
        if (anyRolOrGroup) {
          //  agregar rol de portal empresa en achs virtual
          const idRoles = selectedUser.Roles.map((r) => r.Id);
          idRoles.push(rolPortalEmpresa.Id);
          const req = await overrideRolesForUser(
            selectedUser.Rut,
            selectedUser.RelationTypeCode,
            CompanyRut,
            idRoles,
            true
          );
          if (req.status !== 200) {
            const latestState = store.getState().asignacionRoles;
            latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
              detail: "Error al agregar el Rol de Portal Empresa",
              state: constants.stateError,
            };
            dispatch(setLoadingResumeData(latestState.loadingResumeData));
            return;
          }
          // }
          //  si tiene el rol en archVirtual
        } else {
          // quitar el rol de portal empresa en achs virtual
          const idRoles = selectedUser.Roles.filter(
            (r) => r.Id !== rolPortalEmpresa.Id
          ).map((r) => r.Id);
          const req = await overrideRolesForUser(
            selectedUser.Rut,
            selectedUser.RelationTypeCode,
            CompanyRut,
            idRoles,
            true
          );
          if (req.status !== 200) {
            const latestState = store.getState().asignacionRoles;
            latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
              detail: "Error al quitar el Rol de Portal Empresa",
              state: constants.stateError,
            };
            dispatch(setLoadingResumeData(latestState.loadingResumeData));
            return;
          }
        }
        const latestState = store.getState().asignacionRoles;
        latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
          detail: "Se han actualizado los permisos",
          state: constants.stateSuccess,
        };
        dispatch(setLoadingResumeData(latestState.loadingResumeData));
      } else {
        const latestState = store.getState().asignacionRoles;
        latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
          detail: "Error al guardar los permisos",
          state: constants.stateError,
        };
        dispatch(setLoadingResumeData(latestState.loadingResumeData));
      }
    } else {
      const latestState = store.getState().asignacionRoles;
      latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
        detail: "Error al guardar los permisos",
        state: constants.stateError,
      };
      dispatch(setLoadingResumeData(latestState.loadingResumeData));
    }
  } catch (e) {
    const latestState = store.getState().asignacionRoles;
    latestState.loadingResumeData[constants.idTabPortalEmpresa] = {
      detail: "Error al guardar los permisos",
      state: constants.stateError,
    };
    dispatch(setLoadingResumeData(latestState.loadingResumeData));

    trace.error("addRolesPortalEmpresaToUser", e);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
};

export const addRolesAchsGestionToUser = (userData) => async (dispatch) => {
  const toast = {};
  try {
    const { loadingResumeData } = store.getState().asignacionRoles;
    loadingResumeData[constants.idTabAchsGestion] = {
      detail: "Error al guardar los permisos",
      state: constants.stateError,
    };
    dispatch(setLoadingResumeData(loadingResumeData));
  } catch (e) {
    trace.information("ERROR", e);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
};

export const addRolesLGFToUser = (userData) => async (dispatch) => {
  const toast = {};
  try {
    const { loadingResumeData } = store.getState().asignacionRoles;

    loadingResumeData[constants.idTabLGF] = {
      detail: "Error al guardar los permisos",
      state: constants.stateError,
    };
    dispatch(setLoadingResumeData(loadingResumeData));
  } catch (e) {
    trace.information("ERROR", e);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
};

export const getRolesByProfileId = (idProfile) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const response = await allRolesByProfileId(idProfile);
    const result = await response.json();
    if (response.ok) {
      if (result.Success) {
        const names = [];
        result.Data.forEach((rol) => {
          names.push({ text: rol.Name, value: rol.Name });
        });
        dispatch(setRolesFilter(names));
        dispatch(setRoles(result.Data));
      } else {
        toast.isToastOpen = true;
        toast.msgToast = "No existen Roles validos";
        toast.typeStyle = "error";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
      }
    } else {
      toast.isToastOpen = true;
      toast.msgToast = "Serivicio no responde";
      toast.typeStyle = "error";
      toast.displayTime = 5000;
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const getUserByComanyId = (companyId, page, size, filter, filterRoles) => async (
  dispatch,
  getState
) => {
  dispatch(loading(true));
  //Obtener el count para validar sí debe actualizar la cantidad de paginas
  const {
    asignacionRoles: { employees: employeesPrev },
    global: { myCompanyRoles }
  } = getState();

  const toast = {};

  try {
    const response = await getEmplyeesByCompanyRut(
      companyId,
      page,
      size,
      filter,
      filterRoles,
      myCompanyRoles[companyId?.toLowerCase()]
    );
    const result = await response.json();

    if (response.ok) {
      if (employeesPrev && result.Count == -1) {
        result.Count = employeesPrev.Count;
      }
      dispatch(loading(false))
      await dispatch(setEmployees(result));
    } else {
      dispatch(loading(false))
      throw new Error(response.status);
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const addRolesToUser = (userData, CompanyRut, idRoles) => async (
  dispatch
) => {
  const toast = {};
  const {
    loadingResumeData,
    currentPage,
    currentSize,
    employeeSearch,
  } = store.getState().asignacionRoles;
  try {
    loadingResumeData[constants.idTabAchsVirtual] = {
      detail: "",
      state: constants.stateLoading,
    };
    dispatch(setLoadingResumeData(loadingResumeData));
    const response = await overrideRolesForUser(
      userData.Rut,
      userData.RelationTypeCode,
      CompanyRut,
      idRoles,
      false
    );
    const result = await response.json();
    if (response.ok) {
      if (result.Success) {
        const latestState = store.getState().asignacionRoles;
        dispatch(
          getUserByComanyId(
            CompanyRut,
            currentPage,
            currentSize,
            employeeSearch
          )
        );
        latestState.loadingResumeData[constants.idTabAchsVirtual] = {
          // detail: "Se han actualizado los permisos",
          state: constants.stateSuccess,
        };
        dispatch(setLoadingResumeData(latestState.loadingResumeData));
        dispatch(
          openCloseToast({
            isToastOpen: true,
            msgToast: "Se ha actualizado el permiso del usuario con éxito.",
            typeStyle: "success",
            displayTime: 5000
          })
        );
      }
    } else {
      loadingResumeData[constants.idTabAchsVirtual] = {
        detail: "Error al guardar los permisos",
        state: constants.stateError,
      };
      dispatch(setLoadingResumeData(loadingResumeData));
    }
  } catch (error) {
    trace.information("ERROR", error);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión, intente mas tarde",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
};

export const deleteRolesToUser = (data) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const response = await deleteRolesByUser(data);
    const result = await response.json();
    if (response.ok) {
      if (result.Success) {
        toast.isToastOpen = true;
        toast.msgToast = "Eliminacion de roles";
        toast.typeStyle = "success";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
      }
    } else {
      toast.isToastOpen = true;
      toast.msgToast = result.Message;
      toast.typeStyle = "error";
      toast.displayTime = 5000;
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const addUsersToRol = ({ IdRol, CompanyRut, users }) => async (
  dispatch
) => {
  dispatch(loading(true));
  const toast = {};
  try {
    const response = await createUserByRol(IdRol, CompanyRut, users);
    const result = await response.json();
    if (response.ok) {
      if (result.Success) {
        dispatch(getUserByComanyId(CompanyRut));
        toast.isToastOpen = true;
        toast.msgToast = "Rol asignado a usuarios seleccionados";
        toast.typeStyle = "success";
        toast.displayTime = 5000;
        dispatch(openCloseToast(toast));
      }
    } else {
      toast.isToastOpen = true;
      toast.msgToast = result.Message;
      toast.typeStyle = "error";
      toast.displayTime = 5000;
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

export const setListasPortalEmpresa = (grupos, roles) => ({
  type: "SET_LISTAS_PORTAL_EMPRESA",
  grupos,
  roles,
});

export const getListasPortalEmpresa = () => async (dispatch) => {
  try {
    let grupos = [];
    let roles = [];

    const reqGroup = await getAllGruposPortalEmpresa();
    if (reqGroup.status === 200) {
      const resGroup = await reqGroup.json();
      grupos = resGroup.Grupos.map((item) => ({
        Id: item.Nombre,
        Name: item.Descripcion || item.Nombre,
        Description: "",
        roles: item.Roles,
      }));
    }

    const reqRoles = await getAllRolesPortalEmpresa();
    if (reqRoles.status === 200) {
      const resRoles = await reqRoles.json();
      roles = resRoles.Roles.map((item) => ({
        Id: item.Id_Rol,
        Name: item.Descripcion || item.Nombre,
        Description: "",
      }));
    }

    dispatch(setListasPortalEmpresa(grupos, roles));
  } catch (e) {
    const toast = {};
    trace.information("ERROR", e);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente mas tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000;
    dispatch(openCloseToast(toast));
  }
};

export const doGetRolesTrabajadorFilters = roles => async dispatch => {
  if(roles) {
    let filters = []

    const values = roles.filter(role => role.Id === +process.env.REACT_APP_DEPENDENT_WORKER_ROL || role.Id === +process.env.REACT_APP_EX_ACHS_WORKER_ROL).map(role => ({ text: role.Name, value: role.Id, code: role.Code }))

    filters.push({
      column: 'TipoRolTrabajador',
      name: 'Roles Trabajador',
      showName: false,
      type: 'object',
      values
    })
    dispatch(setRolesTrabajadorFilterGestion(filters))
  }
}

let IDS = [1, 74, 2, 70, 76, 11, 81, 75, 79, 87, 78, 77, 88, 12, 82, 83, 84]

if(process.env.REACT_APP_ENV !== 'production')
  IDS = [1, 74, 2, 70, 76, 11, 81, 75, 79, 87, 78, 77, 88, 12, 82, 83]

export const doGetRolesEmpresaFilters = roles => async dispatch => {
  if(roles) {
    let filters = []
    const values = roles.filter(role => IDS.includes(role.Id)).map(role => ({ text: role.Name, value: role.Id, code: role.Code }))
    const order = IDS.reduce((prev, curr) => {
      const aux = values.find(v => v.value === curr)

      if(aux)
        prev.push(aux)

      return prev
    }, [])

    filters.push({
      column: 'TipoRolEmpresa',
      name: 'Roles Empresa',
      showName: false,
      type: 'object',
      values: order
    })
    dispatch(setRolesEmpresaFilterGestion(filters))
  }
}
